
import { defineComponent } from "vue";
import { NModal } from 'naive-ui';


export default defineComponent({

    components: {
        NModal,
    },

    props: {
        title: { type: String },
        width: { type: String, default: '640px'},
        height: { type: String, default: null},
        buttons: { type: Boolean, default: false}
    },

    data() {
        return {
            show: false
        };
    },

    methods: {

        close(result: boolean = false): void {
            this.show = false;
            this.$emit('closed', result);
        },

        open(): void {
            this.show = true;
        },
    },
})

